import { render, staticRenderFns } from "./CreateEventDialog.vue?vue&type=template&id=fdffb11e&scoped=true"
import script from "./CreateEventDialog.vue?vue&type=script&lang=ts"
export * from "./CreateEventDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdffb11e",
  null
  
)

export default component.exports